/* eslint-disable react/prop-types */
import React, { Fragment, useState, useMemo } from "react"
import ReactDOM from "react-dom"
import useStyles from "./styles"
import { IconButton, Toolbar, Typography, Chip } from "@material-ui/core"
import FilterIcon from "@material-ui/icons/FilterList"
import FiltersDialog from "./FiltersDialog"
import { isEqual, update } from "lodash"

const SelectedFilters = ({ filters, onDelete }) => {
  const classes = useStyles()

  const handleDelete = (filter) => {
    onDelete(filter)
  }

  return ReactDOM.createPortal(
    <Toolbar variant="dense" className={classes.filtersToolbar}>
      <Typography variant="subtitle2" className={classes.filtersTypography}>
        Filters:
      </Typography>
      <div className={classes.filtersChips}>
        {filters.map((filter) => (
          <Chip
            key={filter.label}
            className={classes.selectedFilterChip}
            label={filter.label}
            onDelete={() => handleDelete(filter)}
            color="primary"
          />
        ))}
      </div>
    </Toolbar>,
    document.getElementById("selected-filters"),
  )
}

const FilterControls = ({ onFilter, controls }) => {
  const classes = useStyles()

  const [filtersDialogOpen, setFiltersDialogOpen] = useState(false)
  const [filters, setFilters] = useState(controls)
  const [filterType, setFilterType] = useState("AND")

  const selectedFilters = useMemo(() => {
    return filters.filter((f) => f.checked)
  }, [filters])

  const handleClick = () => {
    setFiltersDialogOpen(true)
  }

  const handleFilterDialogClose = (filters, filterType) => {
    setFilters(filters)
    setFilterType(filterType)
    onFilter?.(
      filters.filter((f) => f.checked).map((f) => f.filter),
      filterType,
    )
    setFiltersDialogOpen(false)
  }

  const handleDeleteFilter = (filter) => {
    const newFilters = filters.map((f) => {
      if (isEqual(f, filter)) {
        f = {
          ...f,
          checked: false,
        }
      }
      return f
    })
    setFilters(newFilters)
    onFilter?.(
      newFilters.filter((f) => f.checked).map((f) => f.filter),
      filterType,
    )
  }

  return (
    <Fragment>
      <IconButton onClick={handleClick} className={classes.filterButton}>
        <FilterIcon />
      </IconButton>
      <FiltersDialog
        open={filtersDialogOpen}
        onClose={handleFilterDialogClose}
        filters={filters}
        filterType={filterType}
      />
      {selectedFilters.length > 0 && (
        <SelectedFilters
          filters={selectedFilters}
          onDelete={handleDeleteFilter}
        />
      )}
    </Fragment>
  )
}

export default FilterControls
